module.exports = __webpack_public_path__ + "img/download_img_app@2x.e1c023ac.png";